export default "__VITE_ASSET__CbCHOBOZ__"